import { DEVELOPMENT } from "util/Dev";
import { FormularioContextProps } from "view/component/Formulario/Formulario";
import { CampoFormularioProps, RestricaoCampoFormulario } from "../RestricaoCampoFormulario"


/**
 * Gera as propriedades referentes ao estado do campo, respeitando as restrições informadas
 */
export class CampoFormularioPropsBuilder {

  /**
   * Utilitário para obter as restrições de um campo conforme as Restrições definidas a ele
   * 
   * @param context Contexto do formulário (Veja Formulario)
   * @param name Name do input
   * @param restricao Restrição do campo. Caso não passado,
   *                  tentará pegar do context de acordo com o name do input
   */
  public static build(context: FormularioContextProps, name?: string, restricao?: CampoFormularioProps) {
    const restricaoVindaDoFormulario = this.restricaoDoFormulario(context, name);
    if (restricaoVindaDoFormulario === undefined && name !== undefined && DEVELOPMENT) {
      console.warn(`O componente de name "${name}" não possui restrições definidas (nem pelo atributo "restricao" nem pelas restrições do formulário).`);
    }

    const restricaoPassadaExplicitamente = restricao ?? {};
    
    const restricaoConsiderada: CampoFormularioProps = {
      loading: context.carregando,
      ...restricaoVindaDoFormulario,
      ...restricaoPassadaExplicitamente,
    }

    return restricaoConsiderada;
  }

  private static restricaoDoFormulario(context: FormularioContextProps, name?: string): RestricaoCampoFormulario|undefined {
    const restricoesFormulario = context.restricoes;
    const operacao = context.operacao;
    
    if (name === undefined || restricoesFormulario === undefined) {
      return undefined;
    }

    const restricoesOperacoesCampo = restricoesFormulario[name];

    if (restricoesOperacoesCampo === undefined) {
      return undefined;
    }

    return restricoesFormulario[name][operacao];
  }
}